export default {
	title: 'Recall RFID  Packing & Verifying System',
	language: 'Language',
	zh: '中文简体',
	en: 'English',
	早上好: 'Good morning',
	中午好: 'Good afternoon',
	下午好: 'Good afternoon',
	晚上好: 'Good evening',
	服装: 'Clothing',
	鞋类: 'Footwear',
	管理员: 'Administrator',
	只读管理员:'readAdministrator',
	普通用户: 'Users',
	禁用: 'Disabled',
	正常: 'Normal',
	用户登录: 'Login',
	扫描单保存: 'PDA Submit',
	EPC明细导出: 'Export of Boxs details',
	修改设备: 'Edit Device',
	删除设备: 'Remove Device',
	添加设备: 'Create Device',
	未上传:'Not uploaded',
	上传成功:'Upload successful',
	上传失败:'Upload failed',
	开始日期:'startDate',
	结束日期:'endDate',
	404: '网页失联了',
	back: 'Back',
	goHome: 'Back to top page',
	placeholder: 'Enter ',
	login: {
		title: 'welcome',
		submit: 'Login',
	},
	updatePassword: 'Edit Password',
	logout: 'Logout',
	name: 'User Name',
	username: 'Account number',
	password: 'Password',
	oldPwd: 'Old password',
	Pwd: 'New passwords',
	twoPwd: 'Confirm password',
	okPwd: 'The confirmation password does not match the new password.',
	pwdTip: 'Password changed successfully！',
	confirm: 'Confirm',
	submit: 'Submit',
	search: 'Query',
	create: 'Create',
	edit: 'Edit',
	cancel: 'Cancel',
	export: 'Exporting',
	export1: 'Export summaries',
	export2: 'Export details',
	serial: 'Serial number',
	operate: 'Operations',
	del: 'Remove',
	tip: 'Tips',
	tipOk: "Sure, I'll delete it.",
	success: 'successful',
	unsuccess: 'unsuccessful',
	article: 'The article',
	goods_sku:"SKU",


	history: 'Boxing inquiry',
	single:'Single',
	double:'Double',
	
	factory_number: 'Factory number',
	factoryNumber: 'Factory number',
	factory_name: 'Factory Name',
	factoryName: 'Factory Name',
	work_order_number: 'Order number',
	
	tipo_depr: 'Product type',
	goods_type: 'Product type',
	
	modelo: 'Product model',
	goods_style: 'Product model',
	
	calidad: 'Product quality',
	goods_quality: 'Product quality',
	
	color: 'Product color',
	goods_colour: 'Product color',
	
	talla: 'Product dimensions',
	goods_size: 'Product dimensions',
	
	create_time: 'Creation time',
	order_number: 'Container number',
	
	all_number: 'Quantity',
	count_number: 'Quantity',

	equ: 'Device',
	device_name: 'Device name',
	device_model: 'Devicemodel',
	device_type: 'Device type',
	device_id: 'Device ID',
	device_version: 'Device version',
	longitude: 'Longitude',
	latitude: 'Latitude',
	user: 'User',
	type: 'User Level',
	log: 'Logs',
	config: 'Configuration',
	
	
	paramKey:'ParamKey',
	paramValue:'ParamValue',
	remark:'Remark',
	serialNo:'SerialNo',
	serial_no:'SerialNo',
	expiration_time:'Expiration time',
	id:'Creation ID',
	upload_state:'Status',
	marca_comercial:'Brand',
	retryUpload:'Reupload',
};